import { render, staticRenderFns } from "./OpenProjects.vue?vue&type=template&id=8b2f5312&scoped=true&"
import script from "./OpenProjects.vue?vue&type=script&lang=js&"
export * from "./OpenProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2f5312",
  null
  
)

export default component.exports